// extracted by mini-css-extract-plugin
module.exports = {"defaultView":"DefaultView_defaultView__sMBIZ"};